import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-jacobs-vehicle-system',
  templateUrl: './jacobs-vehicle-system.component.html',
  styleUrls: ['./jacobs-vehicle-system.component.scss']
})
export class JacobsVehicleSystemComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
